export default __webpack_public_path__ + "static/media/empty-homework-teacher.585a5ff9.png";